<template>
	<span>
		<v-row no-gutters>
			<v-col
				class="pb-0"
			>
				<v-radio-group
					v-model="multiplier"
					inline
				>
					<v-radio
						label="Daily"
						:value="1"
						color="primary"
					/>
					<v-radio
						label="Weekly"
						:value="7"
						color="primary"
					/>
				</v-radio-group>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col
				class="d-flex align-center pt-0"
			>
				<translate
					class="pr-2"
				>
					Every
				</translate>
				<v-select
					v-model="input"
					hide-details
					variant="outlined"
					:items="range(1,50)"
					class="flex-shrink-1 flex-grow-0"
				/>
				<span
					class="pl-2"
				>
					{{ $gettext(`${map[multiplier]}(s)`) }}
				</span>
			</v-col>
		</v-row>
	</span>
</template>

<script>
import {
	range,
} from 'lodash';

export default {
	name: 'RecurringSelect',
	props: {
		value: {
			type: Number,
			required: false,
			default: 1
		}
	},
	emits: ['input',],
	data () {
		return {
			multiplier: 1,
			input: 1,
			map: {
				1: 'day',
				7: 'week'
			}
		};
	},
	watch: {
		input (newInput) {
			this.$emit('input', newInput * this.multiplier);
		},

		multiplier (newMultiplier) {
			this.$emit('input', this.input * newMultiplier);
		},
	},
	methods: {
		range
	}
};
</script>

<style scoped>

</style>
